import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private jwtHelperService = inject(JwtHelperService);
  private authService = inject(AuthService);

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    const accessToken = localStorage.getItem('userToken');
    if (accessToken && !this.jwtHelperService.isTokenExpired(accessToken)) {
      return true;
    }

    // Expired/missing access token. On a full page reload this guard runs
    // before any HTTP call can 401, so the interceptor's silent refresh never
    // gets a chance — refresh here instead of bouncing straight to login.
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      return this.router.createUrlTree(['login']);
    }

    return this.authService.refreshToken(refreshToken).pipe(
      map((response: any) => {
        const newAccessToken = response?.data?.access_token;
        const newRefreshToken = response?.data?.refresh_token;
        if (newAccessToken && newRefreshToken) {
          localStorage.setItem('userToken', newAccessToken);
          localStorage.setItem('refreshToken', newRefreshToken);
          return true;
        }
        this.authService.logout();
        return this.router.createUrlTree(['login']);
      }),
      catchError(() => {
        this.authService.logout();
        return of(this.router.createUrlTree(['login']));
      }),
    );
  }
}
